import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CotacoesComponent } from './cotacoes.component';
import { RouterModule } from '@angular/router';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { PageModules } from 'src/app/utils/pageModules';
import { ListaScrollingModule } from 'src/app/components/lista-scrolling/lista-scrolling.module';
import { MatMenuModule } from '@angular/material/menu';
import { CotacoesSharedModule } from './cotacoes-shared.module';
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path: '', component: CotacoesComponent}
    ]),
    ModulosDeFormulario,
    PageModules,
    ListaScrollingModule,
    MatMenuModule,
    CotacoesSharedModule ,
  ],
})
export class CotacoesModule { }
